import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id F5A29B6C-A003-423D-912A-A23D40E51D3C
 * name gate-open
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-open.svg
 * tags
 * - Home Automation 
 */
export const GateOpenIcon = createSvgIcon(<><path d="M7 21V7H5V11H3V9H1V21H3V19H5V21H7M3 17V13H5V17H3M21 9V11H19V7H17V21H19V19H21V21H23V9H21M21 17H19V13H21V17Z" /></>, 'GateOpenIcon');
export default GateOpenIcon